import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { RoleDTO } from "../models/User/RoleDTO";
import { UserCreateDTO } from "../models/User/UserCreateDTO";
import { UserListDTO } from "../models/User/UserListDTO";
import { UserStatusUpdateDTO } from "../models/User/UserStatusUpdateDTO";
import { APIService } from "./APIService";

export class AdminService{
    async GetAll(searchParameters: Parameter[], sortingParameters: Parameter[], currentPage: number, pageSize: number): Promise<PaginatedList<UserListDTO>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/admin/getAll`, {
                searchParameters,
                sortingParameters,
                currentPage,
                pageSize
            }, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + APIService.GetToken()
                }
            });
            return response.data;
        } catch (error) {
            return new PaginatedList<UserListDTO>(false, "Erro ao obter a informação dos utilizadores", "", [], 0);
        };
    } 

    async GetRoles(): Promise<MessagingHelper<RoleDTO[]>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/admin/GetRoles`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + APIService.GetToken()
                }
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<RoleDTO[]>(false, "Erro ao obter os tipos de utilizadores", []);
        };
    }

    async CreateUser(createUserStatus: UserCreateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/admin/Create`,
                {
                    ...createUserStatus
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(false, "Erro ao criar o utilizador", null);
        };
    }

    async UpdateUserStatus(userId: string, updatedUserStatus: UserStatusUpdateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/admin/UpdateUserStatus/${userId}`,
                {
                    ...updatedUserStatus
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(false, "Erro ao atualizar o utilizador", null);
        };
    }
}